//import { Link } from "react-router-dom";
import projects from "../projects";

export default function PageProjects() {
  return (
    <>
      <main className="max-w-6xl mx-auto px-6 py-12 text-slate-800 font-sans space-y-8">
        <h2 className="text-3xl font-semibold text-center text-purple-800">
          Projects
        </h2>

        <p className="text-lg text-slate-600 text-center m-0">
          My projects are coming soon! 🚀
        </p>
        <p className="m-0 text-center text-lg text-slate-600">
           I'm reorganizing the projects I want to share, check back in a few days.
        </p>

        <section className="grid gap-6 md:grid-cols-2">
          {projects.map((project) => (
            <article
              key={project.slug}
              className="rounded-2xl border border-purple-100 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
            >
              {/* <div className="space-y-4">
                <div className="space-y-2">
                  <h3 className="m-0 text-2xl font-semibold text-slate-900">
                    {project.name}
                  </h3>
                  <p className="m-0 text-sm leading-6 text-slate-600">
                    {project.description}
                  </p>
                </div>

                <div className="flex flex-wrap gap-3">
                  <Link
                    to={`/projects/${project.slug}`}
                    className="inline-flex items-center justify-center rounded-md bg-purple-700 px-4 py-2 text-sm font-medium text-white transition hover:bg-purple-800"
                  >
                    Open project
                  </Link>
                  <a
                    href={project.repoUrl}
                    className="inline-flex items-center justify-center rounded-md border border-purple-700 px-4 py-2 text-sm font-medium text-purple-700 transition hover:bg-purple-50"
                  >
                    Repository
                  </a>
                </div>
              </div> */}
            </article>
          ))}
        </section>
      </main>
    </>
  );
}